export default __webpack_public_path__ + "static/illustration-2-d33c6ba11c0ba0fe7c48a489087413fb.png";